import React, { Component } from 'react';

//other components
import SingleUploadFileBox from "./SingleUploadFileBox";

//generic functions
import {
    isEmpty,
    copyArrObject
} from "../../../functions/generic_functions";

//constants
const DEFAULT_MAX_FILE_SIZE = 20000000;
const ACCEPTED_FILE_TYPES = [".doc, .docx, .pdf"];

/*
    props: 
        className => to format
        name => name of input
        maxFileSize => max size in bytes for this input file
        showMaxFileSize => true/false shows or hides max file size
        placeholder => placeholder text of file box
        defaultValue => the set value of the dropdown
        required => true/false sets the required field for input text
        disabled => true/false disabling box
        showMinMaxFileNum => true/false to show max and min files at top of multi file box
        uploadedFileList => the uploaded list for files on page reload to set expected structure: [{fileName: "", fileSize: 0}, {fileName: "", fileSize: 0},{fileName: "", fileSize: 0},]
        uploadSingleClassName => class name for single file upload

        uploadBySubmit => true/false, if false, will upload immediately based on the link, if true, the upload will occur elsewhere and the file will be set to the parent from the onChangeSetParent function
        [
            {
                app_doc_id, 
                fileName,
                fileSize,
                uploadDate,
            }
        ]

        acceptedFileTypes => the types of files this file input accepts in the format of : ".doc, .docx, .pdf"

        onChangeSetParentState => function on change to call set parent state or grab data from api after upload

        onFileUpload => call back function to handle file upload
        onFileDelete => call back function to handle file deletion
        onFileReplaceUpload => call back function to handle file replace upload

        enableDeleteMode => true/false to enable or disable delete mode
        doc_type => doc type of this multi file upload
        files => list of files for this multi file box
*/

class MultiUploadFileBox extends Component {
    
    constructor(props) {
        super(props);

        //rendering file functions
        this.renderSingleFileUploadBox = this.renderSingleFileUploadBox.bind(this);
        this.renderMultipleFileUploadBoxes = this.renderMultipleFileUploadBoxes.bind(this);
        this.renderMaxMinNumFilesLabel = this.renderMaxMinNumFilesLabel.bind(this);

        //generate unique key 
        this.createUniqueNameKey = this.createUniqueNameKey.bind(this);
        this.checkIfNameKeyExists = this.checkIfNameKeyExists.bind(this);
        this.setRequiredForUploadBox = this.setRequiredForUploadBox.bind(this);
    }

    //checks if data is not empty
    isEmpty(data) {
        return (data === undefined || data === "" || data === null);
    }


    //renders the labels
    renderMaxMinNumFilesLabel() {
        return (
            <div>
                <strong className="file_upload_detail_small_label">
                    Min Files: {(!isEmpty(this.props.minNumFiles) ? this.props.minNumFiles : 1)}
                </strong>
                &nbsp;
                &nbsp;
                <strong className="file_upload_detail_small_label">
                    Max Files: {(!isEmpty(this.props.minNumFiles) ? this.props.maxNumFiles : 1)}
                </strong>
                &nbsp;
                &nbsp;
                <strong className="file_upload_detail_small_label">
                    Num Files: {this.state.fileUploadList.length}
                </strong>
            </div>
        );
    }

    checkIfNameKeyExists(newUniqueNameKey) {
        var tempFilesList = copyArrObject(this.props.files);    

        for (var i = 0; i < tempFilesList.length; i++) {
            if (tempFilesList[i].nameKey === newUniqueNameKey) {
                return true;
            }
        }
        return false;
    }

    //creates the next unique namekey that does not exist inside the fileUploadList in state
    createUniqueNameKey() {
        var foundUniqueKey = false;
        var index = 0;
        var newUniqueNameKey = "";

        while (!foundUniqueKey) {
            newUniqueNameKey = this.props.name + "_" + index;

            //check if the name key does not exist inside the file upload list
            if (!this.checkIfNameKeyExists(newUniqueNameKey)) {
                foundUniqueKey = true;
            }
            else {
                index++;
            }
        }
        //return the unique key
        return newUniqueNameKey;
    }


    //render many single upload boxes
    renderMultipleFileUploadBoxes() {
        

        var maxFiles = 1;
        if (!isEmpty(this.props.maxNumFiles)) {
            maxFiles = this.props.maxNumFiles;
        }

        var fileList = [];
        var tempFilesList = copyArrObject(this.props.files);    

        //upload by post
        if (!isEmpty(this.props.uploadBySubmit) 
            && this.props.uploadBySubmit 
        ) {
            //if only one file, do not generate unique key and post by submit
            if (maxFiles === 1) {

                //if no file
                if (!isEmpty(this.props.files) && this.props.files.length < 0) {
                    fileList.push(this.renderSingleFileUploadBox(this.props.name, undefined, 0));
                }
                //if a file exists
                else {
                    let currFile = this.props.files[0];
                    fileList.push(this.renderSingleFileUploadBox(this.props.name, currFile, 0));
                }
                
            }
            //TODO upload by post for multi files
            else {

            }
        }
        //upload immediately
        else {
            //loop through for maximum num files and render each single upload file box
            for (var i = 0; i < maxFiles; i++) {
                //check if the initial uploadfilelist is not empty, then loop through and set those values
                if (!isEmpty(tempFilesList)
                    && !isEmpty(tempFilesList[i])) {

                    let currFile = tempFilesList[i];
                    var currNameKey = currFile.nameKey;

                    fileList.push(this.renderSingleFileUploadBox(currNameKey, currFile, i));
                }
                else {
                    //generate a unique name key for the new file upload box
                    var newUniqueNameKey = this.createUniqueNameKey();

                    fileList.push(this.renderSingleFileUploadBox(newUniqueNameKey, undefined, i));
                    break;
                }
            }
        }
        return fileList;
    }

    //sets the required boolean for the single upload box based on if the minimum num files is not zero, required and the number of currently uploaded files is below the minimum required
    setRequiredForUploadBox() {
        var minNumFiles = 1;
        var currFilesLen = 0;
        if (!isEmpty(this.props.minNumFiles)) {
            minNumFiles = this.props.minNumFiles;
        }
        if (!isEmpty(this.props.files)) {
            currFilesLen = this.props.files.length;
        }
        if(this.props.required
            && currFilesLen < minNumFiles) {
                return true;
        }
        else {
            return false;
        }
    }

    //render a single upload box
    renderSingleFileUploadBox(nameKey, file, i) {
        return (
            <div key={nameKey + "_" + i} className="p-grid">
                <SingleUploadFileBox
                    name={nameKey}
                    maxFileSize={(!isEmpty(this.props.maxFileSize) ? this.props.maxFileSize : DEFAULT_MAX_FILE_SIZE)}
                    showMaxFileSize={this.props.showMaxFileSize}
                    placeholder={this.props.placeholder}
                    acceptedFileTypes={!isEmpty(this.props.acceptedFileTypes) ? this.props.acceptedFileTypes : ACCEPTED_FILE_TYPES}
                    enableDeleteMode={(!isEmpty(this.props.enableDeleteMode)) ? this.props.enableDeleteMode : false}
                    onChangeSetParentState={this.props.onChangeSetParentState}
                    onFileUpload={this.props.onFileUpload}
                    onFileDelete={this.props.onFileDelete}
                    onFileReplaceUpload={this.props.onFileReplaceUpload}
                    onSaveAddCommentsToDocsUploadedModal={this.props.onSaveAddCommentsToDocsUploadedModal}
                    file={file}
                    disabled={this.props.disabled}
                    required={this.setRequiredForUploadBox()}
                    uploadBySubmit={this.props.uploadBySubmit}
                    doc_type={this.props.doc_type}
                    note={!isEmpty(file) ? file.note : ""}
                    displayComment={this.props.displayComment}
                />
            </div>
        )
    }

    render() { 
        return (  
            <div className="p-grid">
                {((!isEmpty(this.props.showMinMaxFileNum)) ? this.props.showMinMaxFileNum : false) 
                ? this.renderMaxMinNumFilesLabel() 
                : null}
                <div className="file_list">
                    {this.renderMultipleFileUploadBoxes()}
                </div>
            </div>
        );
    }
}

export default MultiUploadFileBox;